export default __webpack_public_path__ + "static/media/Ek-Ladki-Bheegi-Bhaagi-Si-Kishore-Kumar.fdc8bdc7.mp3";